import {
  inject
} from '@angular/core';

import {
  CanActivateFn,
  Router
} from '@angular/router';

import {
  PLATFORM_ID
} from '@angular/core';

import {
  isPlatformBrowser
} from '@angular/common';

import {
  AuthService
} from '../service/auth.service';


export const adminAuthGuard: CanActivateFn = () => {

  const router =
    inject(Router);

  const authService =
    inject(AuthService);

  const platformId =
    inject(PLATFORM_ID);


  if (!isPlatformBrowser(platformId)) {

    return true;

  }


  const token =
    authService.getToken();


  if (token && token.trim().length > 0) {

    return true;

  }


  return router.createUrlTree([
    '/admin/login'
  ]);

};
